export const doNothing = () => {
  /**/
};
